/** @jsx jsx */
import { Fragment } from 'react'
import { jsx } from 'theme-ui'
import SponsoredBy from './sponsored-by'
import { query as querySelector, theme as themeSelector } from '../redux/app-selectors'
import { connect } from 'react-redux'
import { product as productSelector } from '../redux/elasticsearch/elasticsearch-selectors'

const VariantSponsoredBy = (props: any) => {
  const { displayText, product, theme, providerLogo, variant } = props

  if (product) {
    const providerLogoUrl = product?._source?.definition?.provider?.logo?.[theme.name.toLowerCase()]

    const newProps = {
      ...props,
      providerLogoSrc: providerLogoUrl,
      providerText: displayText,
    }

    return providerLogoUrl ? <SponsoredBy {...newProps} /> : null
  } else if (providerLogo) {
    return <SponsoredBy {...props} providerName='' providerText={displayText} variant={variant} />
  }

  return <Fragment />
}

const ConnectSponsoredBy = connect((state: any) => ({
  query: querySelector(state),
  product: productSelector(state),
  theme: themeSelector(state),
}))(VariantSponsoredBy)

export default (props: JSX.IntrinsicAttributes) => <ConnectSponsoredBy {...props} />
